import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { useFieldContext } from '.';
import { useId } from 'react';

type RadioOption = {
  value: string;
  label: React.ReactNode;
};

type RadioGroupFieldProps = {
  label: React.ReactNode;
  options: RadioOption[];
  row?: boolean;
  disabled?: boolean;
};

export const RadioGroupField = (props: RadioGroupFieldProps) => {
  const field = useFieldContext<string>();
  const id = useId();
  return (
    <FormControl disabled={props.disabled}>
      <FormLabel id={id}>{props.label}</FormLabel>
      <RadioGroup
        aria-labelledby={id}
        value={field.state.value}
        onChange={(e) => field.handleChange(e.target.value)}
        row={props.row}
      >
        {props.options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
